export default __webpack_public_path__ + "static/media/RealEstatewebservicesbg.eff284c8.svg";